import React, { useCallback } from 'react';
import { ButtonInline, LockText } from 'ui';
import { subscriptionSectionId, SubscriptionTranslations } from 'app/area/user-profile/subscriptions/constants';
import { scrollIntoView } from 'app/infrastructure/platform/browser-dom';
import { SubscriptionStoreValue } from 'app/area/user-profile/subscriptions/types';
import styles from './subscribe-button.scss';

interface SubscribeButtonProps {
  item: SubscriptionStoreValue;
  checked: boolean;
  translation: SubscriptionTranslations;
  onChange: (value: SubscriptionStoreValue, checked: boolean) => void;
}

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  item, checked, translation, onChange
}) => {

  const changeHandler = useCallback(
    () => {
      onChange(item, !checked);
    }, [item, checked, onChange]);

  const handleOnChange = () => {
    changeHandler();
    scrollIntoView(document.getElementById(subscriptionSectionId));
  };

  return (<div className={`${styles.subscribeComponent} ${item.readOnly ? styles.readOnly : ''}`} key={item.value}>
    <div className={styles.header}>
      <div className="control-label pl-0">
        <div className={styles.label}>
          <h3 className={item.readOnly ? styles.readonly : ''}>{item.description}</h3>
        </div>
        {item.readOnly && <LockText text={translation.contact_administrator_info} />}
      </div>

      <div className={styles.subscribeLabelLongDescription}>
        {item.longDescription}
      </div>

      {!item.readOnly && <div className="text-right mt-3">
        <ButtonInline onClick={handleOnChange}>
          {checked ? translation.unsubscribe_button : translation.subscribe_button}
        </ButtonInline>
      </div>}
    </div>
  </div>);
};
